import React from 'react'

export default function ArrowNextBigIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_12872_5156)">
<path d="M22 11L33 22M33 22L22 33M33 22H11" stroke="#071013"/>
</g>
<defs>
<clipPath id="clip0_12872_5156">
<rect width="44" height="44" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}
